import React from 'react'

function MiniFadedChart({ size = 26, color = "currentColor", ...rest }) {
    return (
        <svg {...rest} width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2925_2215)">
                <g filter="url(#filter0_d_2925_2215)">
                    <path d="M7.99967 26.6666C9.46634 26.6666 10.6663 25.4666 10.6663 24V14.6666C10.6663 13.2 9.46634 12 7.99967 12C6.53301 12 5.33301 13.2 5.33301 14.6666V24C5.33301 25.4666 6.53301 26.6666 7.99967 26.6666ZM21.333 20V24C21.333 25.4666 22.533 26.6666 23.9997 26.6666C25.4663 26.6666 26.6663 25.4666 26.6663 24V20C26.6663 18.5333 25.4663 17.3333 23.9997 17.3333C22.533 17.3333 21.333 18.5333 21.333 20ZM15.9997 26.6666C17.4663 26.6666 18.6663 25.4666 18.6663 24V7.99998C18.6663 6.53331 17.4663 5.33331 15.9997 5.33331C14.533 5.33331 13.333 6.53331 13.333 7.99998V24C13.333 25.4666 14.533 26.6666 15.9997 26.6666Z" fill="#FC6432" />
                </g>
            </g>
            <defs>
                <filter id="filter0_d_2925_2215" x="-0.966992" y="-0.966687" width="33.933" height="33.9333" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="3.15" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.988235 0 0 0 0 0.392157 0 0 0 0 0.196078 0 0 0 1 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2925_2215" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2925_2215" result="shape" />
                </filter>
                <clipPath id="clip0_2925_2215">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default MiniFadedChart